import React from 'react'

function TSSCTPView() {
    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                      <div className="top-header page-title">
                        <span>TSSCTPView Details</span>
                      </div>
                        <div className="page-header">
                            <div className="text-end mb-3">
                                <button
                                    className="button-container"
                                >
                                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                                </button>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    TABLE
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default TSSCTPView
